<template>
	<div
		class="map_wrap"
		ref="map_wrap"
	>
		<div
			class="map"
			ref="map"
		>

		</div>
		<div
			class="point"
			ref="point"
		>

		</div>
		<div
			class="tip"
			v-if="!pinched"
		>
			<span class="icon"></span>
			<p>缩放地图<br />点击了解详情</p>
		</div>
	</div>
</template>
<script>
// import d3 from "../libs/d3";
// import * as d3 from "d3";
import Animate from "ztgamejs/css3animate";
import $ from "jquery";
import Hammer from "hammerjs";
import Chengdu from "../api/chengdu";
import Projects from "../api/projects";
import projects from "../api/projects";
var mapSize = 2000;
export default {
	data() {
		return {
			scale: 1,
			wrapSize: null,
			offset: { x: 0, y: 0 },
			pinched: false,
		};
	},
	activated() {
		this.reset();
	},
	mounted() {
		this.$refs.map_wrap.addEventListener("touchmove", (e) => {
			e.stopPropagation();
		});
		var hammertime = new Hammer(this.$refs.map_wrap);
		hammertime.get("pinch").set({
			enable: true,
		});
		var oldscale = this.scale;
		hammertime.on("pinchstart", (ev) => {
			this.pinched = true;
			oldscale = this.scale;
		});
		hammertime.on("pinchmove", (ev) => {
			this.scale = oldscale * ev.scale;
			if (this.scale > 1) {
				this.scale = 1;
			} else if (this.scale < 0.1) {
				this.scale = 0.1;
			}
			this.renderMap();
		});
		var oldoffset = this.offset;
		hammertime.on("panstart", (ev) => {
			oldoffset = this.offset;
		});
		hammertime.on("panmove", (ev) => {
			this.offset = {
				x: oldoffset.x + ev.deltaX,
				y: oldoffset.y + ev.deltaY,
			};
			this.renderMap();
		});
		this.reset();
		Animate.to(
			this.$refs.map,
			{
				scale: this.scale,
			},
			100
		);
		this.renderMap();
		$(window).resize(() => {
			this.renderMap();
		});
	},
	methods: {
		reset() {
			var size = this.getWrapSize();
			this.scale = size.width / mapSize;
			this.scale = this.scale > 0.1 ? this.scale : 0.1;
			this.offset = { x: 0, y: 0 };
			this.$refs.point.innerHTML = "";
			this.renderMap();
		},
		getProjectByArea(areaid) {
			if (!areaid) {
				return null;
			}
			for (var i in projects) {
				if (areaid == projects[i]["areaId"]) {
					projects[i].id = parseInt(i) + 1;
					return projects[i];
				}
			}
			return null;
		},
		transformPos(pos) {
			this.getWrapSize();
			let newpointPos = {
				x:
					(pos.x / 2 - mapSize / 2) * this.scale +
					this.wrapSize.width / 2,
				y:
					(pos.y / 2 - mapSize / 2) * this.scale +
					this.wrapSize.height / 2,
			};
			return newpointPos;
		},
		getWrapSize() {
			let wrapWidth = $(this.$refs.map_wrap).width();
			let wrapHeight = $(this.$refs.map_wrap).height();
			var wrapSize = { width: wrapWidth, height: wrapHeight };
			this.wrapSize = wrapSize;

			return wrapSize;
		},
		gotoList(e) {
			let areaid = $(e.target).data("id");
			let project = this.getProjectByArea(areaid);
			if (!project) {
				alert("该区域暂无项目");
			} else {
				this.$router.replace({
					name: "List",
					params: {
						id: project.id,
					},
				});
			}
		},
		renderMap() {
			// this.$refs.point.innerHTML = "";
			let fontSize = (1.2 * this.scale) / 2;
			fontSize = fontSize < 0.14 ? 0.14 : fontSize > 0.6 ? 0.6 : fontSize;
			let dockSize = (60 * this.scale) / 2;
			dockSize = dockSize < 6 ? 6 : dockSize > 20 ? 20 : dockSize;
			dockSize *= 2;
			Animate.set(this.$refs.map, {
				scale: this.scale,
			});
			Animate.set(this.$refs.map_wrap, {
				x: this.offset.x,
				y: this.offset.y,
			});
			for (var i in Chengdu) {
				let pointPos = Chengdu[i]["pointPos"];

				let div;
				if (pointPos) {
					let newpointPos = this.transformPos(pointPos);
					div = document.getElementById("area_" + i);
					if (!div) {
						div = document.createElement("div");
						div.id = "area_" + i;
						div.setAttribute("data-id", i);
						div.className = "dock";
						if (i.indexOf("gaoxin") > -1) {
							div.className += " gaoxin";
						}
						div.addEventListener("click", (e) => {
							this.gotoList(e);
						});
						this.$refs.point.appendChild(div);
					}

					div.style.cssText = `left:${newpointPos.x}px;top:${newpointPos.y}px;width:${dockSize}px;height:${dockSize}px`;
				}

				let areaPos = this.transformPos(Chengdu[i]["namePos"]);
				div = document.getElementById("areaname_" + i);
				if (!div) {
					div = document.createElement("div");
					div.id = "areaname_" + i;
					div.innerHTML = Chengdu[i]["name"];
					div.setAttribute("data-id", i);
					div.className = "area_name";
					this.$refs.point.appendChild(div);
					if (pointPos) {
						div.addEventListener("click", (e) => {
							this.gotoList(e);
						});
					}
				}

				div.style.cssText = `left:${areaPos.x}px;top:${areaPos.y}px;font-size:${fontSize}rem`;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.map_wrap {
	width: 100%;
	height: 100%;
	z-index: 100;
	position: relative;
	.point {
		width: 100%;
		height: 100%;
		z-index: 10;
		left: 0;
		top: 0;
	}
	/deep/ .dock {
		position: absolute;
		width: 8px;
		height: 8px;
		margin-left: -4px;
		margin-top: -4px;
		z-index: 10;
		border-radius: 5px;
		background: none;

		&::after,
		&::before {
			display: inline-block;
			content: " ";
			width: 50%;
			height: 50%;
			position: absolute;
			left: 0;
			top: 0;
			background: #108fff;
			transform-origin: 50% 50%;
			border-radius: 50%;
			animation: guang 3s ease-out 0s infinite normal both;
		}
		&::after {
			animation-delay: 1.5s;
		}
		&.gaoxin {
			&::after,
			&::before {
				background: #c9f4a0;
			}
		}
	}
	/deep/ .area_name {
		position: absolute;
		color: #fff;
		font-size: 0.2rem;
		line-height: 1.1;
		transform: translate(-50%, -10%);
		z-index: 10;
		white-space: nowrap;
		text-align: center;
	}
	.map {
		width: 2000px;
		height: 2000px;
		background: url("../assets/map.png") no-repeat center;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-left: -1000px;
		margin-top: -1000px;
	}
}
@keyframes guang {
	0% {
		transform: scale(0);
		opacity: 0;
	}
	50% {
		opacity: 0.8;
	}
	100% {
		transform: scale(2);
		opacity: 0;
	}
}
.tip {
	position: absolute;
	top: 12%;
	right: 20%;
	color: #00eef9;
	text-align: center;
	.icon {
    animation: flash 0.6s ease-in-out 0s infinite alternate-reverse both;
		display: inline-block;
		width: 1.2rem;
		height: 1.2rem;
		background: url("../assets/pinch.png") no-repeat center/contain;
  }
  p{
    position: relative;
    left: 0.3rem;
    font-size: 0.24rem;
  }
  
  font-weight: bold;
  line-height: 1.5;
}
@keyframes flash {
	0% {
		opacity: 1;
	}
	100% {
		// opacity: 0.6;
		transform: scale(1.05);
	}
}
</style>